module.exports = __webpack_public_path__ + "static/media/twitter-inverted-logo.631b0e7f.svg";